const keyExistsOn = (o, k) =>
    k
        .split(".")
        .reduce(
            (a, c) => (a.hasOwnProperty(c) ? a[c] || 1 : false),
            Object.assign({}, o)
        ) === false
        ? false
        : true;
export default keyExistsOn